import { Stack, Typography } from '@rossum/ui/material';
import CopyToClipboardButton from '../../../ui/copy-to-clipboard/CopyToClipboardButton';

export const EmailAddress = ({
  inboxAddress,
}: {
  inboxAddress: string | undefined;
}) => {
  if (!inboxAddress) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant="body2" color="text.secondary">
        {inboxAddress}
      </Typography>

      <CopyToClipboardButton content={inboxAddress} iconColor="secondary" />
    </Stack>
  );
};
